import { useMutation } from "@tanstack/react-query";

import { guacHttpClient } from "@/lib/http";
import {
  CreateJobDifficultyUrgencyRequest,
  HttpResponse,
  JobUpdate,
} from "@/types";

export function useCreateJobDifficultyUrgency() {
  const mutation = useMutation({
    mutationFn: async ({
      companyId,
      createJobDifficultyUrgencyRequest,
      jobId,
    }: {
      companyId: string;
      createJobDifficultyUrgencyRequest: CreateJobDifficultyUrgencyRequest;
      jobId: string;
    }) => {
      const path = `companies/${companyId}/jobs/${jobId}/job-difficulty-urgencies`;
      const res = await guacHttpClient.post<
        JobUpdate,
        HttpResponse<JobUpdate>,
        CreateJobDifficultyUrgencyRequest
      >(path, createJobDifficultyUrgencyRequest);
      return res.data;
    },
  });

  return mutation;
}
